import { render, staticRenderFns } from "./DefaultTierTemplateButton.vue?vue&type=template&id=11307941"
import script from "./DefaultTierTemplateButton.vue?vue&type=script&lang=js"
export * from "./DefaultTierTemplateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports